import { FunctionComponent } from 'react'

import { Grid } from '@theme-ui/components'
import { shallowEqual } from 'react-redux'
import { useParams } from 'react-router-dom'

import { Text } from '@fairhq/common'
import { useAreaProgress } from 'features/assessmentQuestions/hooks/useAreaProgress'
import { useAreas } from 'hooks/useAreas'
import { State } from 'store/state'

import { Layout } from '../../layout/Layout'
import { PageTop } from '../../layout/PageTop'

import { useAppSelector } from '../../store/hooks'

import { LocalArea } from './LocalArea'

export const LocalAreas: FunctionComponent = () => {
  const { code = '' } = useParams<{ code: string }>()
  const { parentArea, areas } = useAppSelector(
    (state: State) => ({
      parentArea: state.areaReducer.area,
      areas: state.areaReducer.areas ?? [],
    }),
    shallowEqual
  )
  const { completed, total } = useAreaProgress({ area: { code } })

  useAreas({})

  const content = areas?.filter(area => area.parentAreaCode === code)

  return (
    <Layout dark>
      <PageTop>
        <Text fontWeight={700} size="xl" element="h1" type="heading">
          {parentArea?.title}
        </Text>
        <Text fontWeight={600} size="lg" element="h1" type="heading">
          {Math.round((completed * 100) / total) || 0}%
        </Text>
      </PageTop>

      <Grid columns={1} gap={1} sx={{ alignItems: 'flex-start' }}>
        {areas.length > 0 ? (
          <>
            {content.map(({ code, title }) => (
              <LocalArea key={code + Math.random()} label={title} code={code} />
            ))}
          </>
        ) : null}
      </Grid>
    </Layout>
  )
}
